import { initialState } from "@/models/options";

const v19 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        invoicesTable: {
          ...initialState.tableViews.invoicesTable,
        },
        freelancersTable: {
          ...state.options.tableViews.freelancersTable,
          "Last Edited": true,
          "Created by": true,
        },
      },
    },
  };
};

export default v19;
